(function () {
      const siteName = "MyDriveRate";
      const privacyPolicyLink = "/pages/privacy-policy";
      const cookiePolicyLink = "/pages/cookie-policy";
      const doNotSellLink = "/pages/do-not-sell-my-personal-information";

      const style = `@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);
.cookie-consent-banner{background-color:#fff;display:none;z-index:99999;background:rgba(0,0,0,.5);width:100%;height:100%;overflow:hidden;position:fixed;top:0;bottom:0;left:0;right:0;font-size:14px;color:#494948;font-family:Montserrat!important;box-sizing:border-box; font-weight: normal; line-height: normal;}.cookie-consent-banner *,.cookie-consent-banner *::before,.cookie-consent-banner *::after{box-sizing:border-box}.cookie-banner-body{background-color:#fff;z-index:150;position:fixed;right:0;margin:0 auto;max-height:90dvh;overflow-x:hidden;overflow-y:auto;box-shadow:0 0 18px rgba(0,0,0,.2);border:1px solid rgba(73,73,72,0);outline:0;top:50%;left:0;max-width:475px;width:calc(100% - 20px);border-radius:20px;transform:translateY(-50%)}.main-banner-content{width:100%;padding:25px}.text_block{margin:0 0 20px}.cookie-consent-banner p{margin:0;line-height:1.5;text-align:left;margin-bottom: 5px;}.checkboxes-block-title,.cookie-consent-options-content h2{color:#494948;width:100%;text-align:left;margin:0 0 10px;font-size:13px;font-style:normal;font-weight:500;letter-spacing:.03em;line-height:110%;font-family:Montserrat!important}.policy-link,.policy-link:hover{color:#121212}.cookie-consent-options-desc p{color:#494948;line-height:1.5;margin-bottom:25px;font-size:12px;font-weight:400}.cookie-consent-options{display:flex;justify-content:center;flex-wrap:wrap}.policy-link{display:inline-block;text-decoration:underline}.main-banner-content .text_block h3,.main-banner-content .text_block h4{margin:0 0 13px;font-size:16px;font-weight:600;line-height:1.5em}
.cookie-consent-button,.cookie-setting-button{appearance:none;cursor:pointer;overflow:hidden;white-space:nowrap;outline:0;text-transform:uppercase;text-align:center;font-size:13px;font-weight:400;letter-spacing:.03em;line-height:23px;align-items:center;justify-content:center;display:inline-flex;padding:9px 16px;margin:0;word-break:normal;word-wrap:normal;height:auto;min-height:43px;min-width:0;position:relative;font-family:Montserrat!important;transition:background-color .25s ease,border-color .25s ease,color .25s ease,transform .25s ease}.cookie-consent-button:hover,.cookie-setting-button:hover{transform:translateY(-1px)}
.button-container{display:grid;grid-template-columns:minmax(0,1fr) 2fr;gap:12px;width:100%;align-items:center}.button-container .button-group-right{display:flex;gap:10px;justify-content:flex-end;align-items:center;min-width:0}.main-banner-content .cookie-setting-button{grid-column:1;color:#494948;background:transparent;border:1px solid transparent;text-decoration:none;opacity:1;font-size:12px;white-space:normal;padding-block:0;justify-content:flex-start;width:fit-content;padding-right:15px;padding-left:0;text-align:left}.main-banner-content .cookie-setting-button::after{content:"";position:absolute;top:50%;right:0;z-index:4;width:12px;height:12px;background-image:url(https://cdn.shopify.com/s/files/1/0457/9593/4375/files/9lydl7x9vrrm0qi9gdc.svg?v=1725614502);background-position:center;background-repeat:no-repeat;background-size:6px;transform:translateY(-50%);transition:transform .3s}.main-banner-content .cookie-setting-button:hover::after{transform:translate(2.5px,-50%)}#btn-accept-all{background-color:#2f79e9;border:1px solid #2f79e9;border-radius:20px;color:#fff;}#btn-accept-all:hover{background-color:#e2eeff;color:#494948}#btn-reject-all{background-color:#fff;color:#2f79e9;border:1px solid #2f79e9;border-radius:20px;}#btn-reject-all:hover{background-color:#e2eeff;color:#2f79e9}.cookie-consent-options-body{max-height:min(820px,calc(100dvh - 32px));height:auto;overflow:hidden;position:fixed;margin:0 auto;right:0;left:0;z-index:200;top:50%;transform:translateY(-50%);max-width:100%;min-width:0;width:min(594px,calc(100% - 28px));padding:0;background:#fff;border-radius:30px;box-shadow:0 4px 10px #0003;display:none;visibility:hidden;opacity:0;flex-direction:column}.cookie-consent-options-body.active{display:flex;visibility:visible;opacity:1}.cookie-consent-options-content{overflow-y:auto;overflow-x:hidden;padding:24px 24px 18px;position:relative;bottom:auto;top:auto;left:auto;width:100%;height:auto;margin:0;flex:1 1 auto;min-height:0}.cookie-consent-options-content::-webkit-scrollbar{width:10px;border-radius:10px}.cookie-consent-options-content::-webkit-scrollbar-track{background:#fff;border-radius:10px}.cookie-consent-options-content::-webkit-scrollbar-thumb{background-color:#d8d8d8;border-radius:10px;border:2px solid #f1f1f1}.cookie-consent-options-content::-webkit-scrollbar-thumb:hover{background:#d8d8d8}.close-btn,.close-btn-block{border:none;top:0;position:absolute}.close-btn-block{height:39px;padding:10px 0 10px 30px;right:0;z-index:2}.close-btn{display:inline-block;text-align:center;cursor:pointer;padding:12px 0;right:0;width:30px;height:40px;margin-bottom:0;background:url(https://cdn.shopify.com/s/files/1/0457/9593/4375/files/vthmgakacbfm0qjsttf.svg?v=1725617054) center left/12px no-repeat #fff;opacity:1}.checkboxes-block{margin:0;max-width:none;display:block;width:100%}.checkboxes-block-title{padding-bottom:10px}#btn-accept-all-2{background-color:#2f79e9;border:1px solid #2f79e9;border-radius:24px;color:#fff;width:100%;margin:8px 0 25px}#btn-accept-all-2:hover{background-color:#e2eeff;color:#494948}.consent-item .open-consent-item-desc{position:absolute;cursor:pointer;width:100%;height:100%;margin:0;top:0;left:0;z-index:1;max-width:none;border:none;outline:0;padding:12px 0;background-color:rgba(0,0,0,0)}.consent-item .consent-item-content{margin:0;justify-content:space-between;position:relative;min-height:25px;align-items:center;display:grid;grid-template-columns:auto minmax(0,1fr) auto;width:100%;gap:12px;padding:14px 0}.consent-item-content .arrow-down{font-size:1.5em;position:relative;display:inline-block;top:0;width:12px;height:12px;background-image:url(https://cdn.shopify.com/s/files/1/0457/9593/4375/files/mlvwmy3qz9fm0qmwhoo.svg?v=1725622219);background-position:center;background-repeat:no-repeat;background-size:12px}.consent-item-content h4{color:#494948;margin:0;display:block;height:auto;word-wrap:break-word;font-weight:500;max-width:100%;vertical-align:middle;font-size:13px;line-height:1.25;font-family:Montserrat!important;min-width:0}.consent-item-content .checkbox-body label{color:#000;align-items:center;display:inline-flex;flex-wrap:wrap;gap:1ch;position:relative;text-align:center}.consent-item-content .checkbox-body input{color:#000;font-size:100%;vertical-align:middle;border:none;line-height:normal;padding:0;margin:0;cursor:pointer;height:100%;opacity:0;position:absolute;width:100%;z-index:4}.consent-item-content .checkbox-body span{justify-content:end;padding-inline:8px;position:relative;transition:.25s;width:34px;display:inline-flex!important;height:24px;color:#727272;border-radius:100vw;box-sizing:content-box;background-color:#ebebeb;align-items:center;font-size:12px;padding-top:2px}.checkbox-body{display:flex;align-items:center;flex-wrap:nowrap;gap:6px;position:relative;z-index:3}.consent-item-content .checkbox-body span::before{background-color:#fff;border-radius:50%;box-shadow:0 1.3px 2.7px rgba(0,0,0,.25);box-sizing:border-box;content:"";height:16px;left:4px;position:absolute;top:50%;transform:translateY(-50%);transition:inherit;width:16px;z-index:3}.consent-item-content .checkbox-body input[type=checkbox]:disabled{cursor:not-allowed}.consent-item-content .checkbox-body input[type=checkbox]:disabled+span{background-color:#535151;color:#fff;justify-content:start}.consent-item-content .checkbox-body input[type=checkbox]:checked:not(:disabled)+span{background-color:#121212;color:#fff;justify-content:start}.consent-item-content .checkbox-body input[type=checkbox]:checked+span::before{transform:translate(26px,-50%)}.consent-item .consent-item-desc{background-color:#fff;margin-top:0;max-height:0;opacity:0;overflow:hidden;width:100%;transition:.25s ease-out;display:none}.consent-item-desc p{color:#494948;padding-left:24px;padding-right:20px;width:100%;font-size:13px;margin:12px 0 10px}.consent-item.opened .consent-item-desc{overflow:auto;display:block;width:auto;padding-bottom:10px;max-height:none;opacity:1}.checkboxes-block .consent-item{position:relative;border-radius:2px;margin:0;padding:0;width:100%;line-height:1.1;display:block;border:none;border-top:1px solid #ececec}.cookie-consent-options-bottom{position:relative;bottom:auto;width:100%;max-height:none;border-top:1px solid #d8d8d8;left:auto;flex:0 0 auto;background:#fff;border-radius:0 0 30px 30px}.cookie-consent-options-bottom .selected-button-block{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;justify-content:stretch;align-items:center;padding:24px 36px 20px}.cookie-consent-options-bottom .cookie-consent-button{width:100%;max-width:none;border-radius:20px}.cookie-consent-options-bottom #btn-accept-all-3{background-color:#2f79e9;border:1px solid #2f79e9;color:#fff}.cookie-consent-options-bottom #btn-accept-all-3:hover{background-color:#e2eeff;color:#494948}.cookie-consent-options-bottom #btn-reject-all-2{background-color:#fff;color:#2f79e9;border:1px solid #2f79e9}.cookie-consent-options-bottom #btn-reject-all-2:hover{background-color:#e2eeff;color:#2f79e9}.cookie-consent-options-bottom #btn-accept-some{background-color:#2f79e9;border:1px solid #2f79e9;color:#fff}.cookie-consent-options-bottom #btn-accept-some:hover{background-color:#e2eeff;color:#494948}
@media screen and (max-width:768.98px){.main-banner-content{flex-wrap:wrap}.button-container{width:100%;grid-template-columns:1fr}.button-container .button-group-right{width:100%;justify-content:stretch}.button-container .button-group-right .cookie-consent-button{width: 100%;width:auto}.main-banner-content .cookie-setting-button{grid-row:2}}
@media screen and (max-width:600px){.cookie-banner-body{max-height:calc(100dvh - 20px);}.button-container{display:flex;flex-direction:column-reverse;align-items:center;row-gap:10px}.button-container .button-group-right{width:100%;flex-direction:column}.button-container .button-group-right .cookie-consent-button{width:100%;max-width:100%}.main-banner-content .cookie-setting-button{width:fit-content}.cookie-consent-options-body{width:calc(100% - 24px);max-height:calc(100dvh - 24px);top:12px;transform:none;border-radius:24px}.cookie-consent-options-content{padding:20px 22px 14px}.cookie-consent-options-bottom{border-radius:0 0 24px 24px}.cookie-consent-options-bottom .selected-button-block{grid-template-columns:1fr;gap:10px;padding:14px 22px 18px}.cookie-consent-button,.cookie-setting-button{min-height:23px}.cookie-consent-options-bottom .cookie-consent-button,#btn-accept-all-2{min-height:43px}.consent-item .consent-item-content{grid-template-columns:auto minmax(0,1fr) auto;gap:10px}.consent-item-content h4{font-size:13px;line-height:1.25}}`;
      const htmlContent = `<div id="cookie-consent-banner" class="cookie-consent-banner"><div class="cookie-banner-body"><div class="main-banner-content"><div class="text_block"><p><strong>Welcome to ${siteName}</strong></p><p>We use cookies to improve your experience on our website. Cookies allow us to remember your preferences and settings, so you don’t have to re-enter them every time you visit our site.
To learn more about cookies and how we use them, please visit our cookie policy: <a class="policy-link" href="${privacyPolicyLink}">Privacy Policy</a>.</p></div><div class="button-container"><button id="cookie-setting" class="cookie-setting-button cookie-setting-gtm">COOKIE SETTINGS</button><div class="button-group-right"><button id="btn-accept-all" class="cookie-consent-button btn-black first-accept-all-gtm">Accept All</button></div></div></div></div><div id="consentOptionsPopup" class="cookie-consent-options-body"><div class="close-btn-block"><button id="consentOptionsPopupClose" class="close-btn"></button></div><div class="cookie-consent-options-content"><h2><b>Privacy Preference Center</b></h2><div class="cookie-consent-options-desc"><p>When you visit a website, it may store or retrieve information in your browser, usually as cookies. This information rarely identifies you directly, but it can make your experience more personalised. Because we respect your privacy, you can choose which categories to allow. Blocking some categories will change how the site works and how relevant the ads you see are. Strictly necessary cookies cannot be switched off.</p></div><button id="btn-accept-all-2" class="cookie-consent-button btn-top sec-accept-all-gtm">Accept All</button><section class="checkboxes-block"><h3 class="checkboxes-block-title"><b>Manage Consent Preferences</b></h3><div class="consent-item"><button class="open-consent-item-desc"></button><div class="consent-item-content"><div class="arrow-down"></div><h4>Strictly Necessary Cookies</h4><div class="checkbox-body"><label><input id="consent-necessary" type="checkbox" value="Necessary" checked="checked" disabled="disabled"><span class="checkbox-text-label"></span></label></div></div><div class="consent-item-desc"><p>Required for the website to function. They handle session state, security, your Quiz progress, and the record of your cookie and opt-out choices. Without them the site will not work correctly. These cookies store no directly identifying information.</p></div></div><div class="consent-item"><button class="open-consent-item-desc"></button><div class="consent-item-content"><div class="arrow-down"></div><h4>Performance / Analytics Cookies</h4><div class="checkbox-body"><label><input id="consent-analytics" type="checkbox" value="Analytics" checked="checked"><span class="checkbox-text-label"></span></label></div></div><div class="consent-item-desc"><p>Let us count visits and see which guides are read and where visitors leave the Quiz, so we can improve the site. The data is aggregated. If you switch these off we lose visibility of how the site performs.</p></div></div><div class="consent-item"><button class="open-consent-item-desc"></button><div class="consent-item-content"><div class="arrow-down"></div><h4>Functional Cookies</h4><div class="checkbox-body"><label><input id="consent-preferences" type="checkbox" value="Preferences" checked="checked"><span class="checkbox-text-label"></span></label></div></div><div class="consent-item-desc"><p>Enable enhanced functionality and personalisation, such as remembering your region and the answers you gave in the Quiz so you do not have to repeat them. They may be set by us or by providers whose services we embed.</p></div></div><div class="consent-item"><button class="open-consent-item-desc"></button><div class="consent-item-content"><div class="arrow-down"></div><h4>Targeting / Advertising Cookies</h4><div class="checkbox-body"><label><input id="consent-marketing" type="checkbox" value="Marketing" checked="checked"><span class="checkbox-text-label"></span></label></div></div><div class="consent-item-desc"><p>Set by our advertising partners. They build a profile of your interests, measure whether our ads worked, cap how often you see them, and show you relevant ads on other sites. They do not store your name or contact details, but they do uniquely identify your browser and device. For U.S. residents, switching these off is how you opt out of the sale and sharing of personal information.</p></div></div></section></div><div class="cookie-consent-options-bottom"><div class="selected-button-block"><button id="btn-accept-all-3" class="cookie-consent-button btn-bottom accept-all-bottom-gtm">Accept All</button><button id="btn-accept-some" class="cookie-consent-button btn-bottom accept-selection-gtm">Save My Choices</button></div></div></div></div>`;

      const styleElement = document.createElement("style");
      styleElement.textContent = style;
      document.head.appendChild(styleElement);

      const bannerContainer = document.createElement("div");
      bannerContainer.innerHTML = htmlContent;
      document.body.appendChild(bannerContainer.firstElementChild);

      function hideBanner() {
        document.getElementById("cookie-consent-banner").style.display =
          "none";
      }

      function setConsent(consent) {
        const consentMode = {
          functionality_storage: consent.necessary ? "granted" : "denied",
          security_storage: consent.necessary ? "granted" : "granted",
          ad_storage: consent.marketing ? "granted" : "denied",
          analytics_storage: consent.analytics ? "granted" : "denied",
          ad_user_data: consent.marketing ? "granted" : "denied",
          ad_personalization: consent.marketing ? "granted" : "denied",
          personalization_storage: consent.preferences ? "granted" : "denied",
        };
        gtag("consent", "update", consentMode);
        localStorage.setItem("consentMode", JSON.stringify(consentMode));
      }

      document
        .getElementById("btn-accept-all")
        .addEventListener("click", function () {
          setConsent({
            necessary: true,
            analytics: true,
            preferences: true,
            marketing: true,
          });
          consentOptionsPopup.classList.remove("active");
          hideBanner();
        });
      document
        .getElementById("btn-accept-all-2")
        .addEventListener("click", function () {
          setConsent({
            necessary: true,
            analytics: true,
            preferences: true,
            marketing: true,
          });
          consentOptionsPopup.classList.remove("active");
          hideBanner();
        });
      document
        .getElementById("btn-accept-some")
        .addEventListener("click", function () {
          setConsent({
            necessary: true,
            analytics: document.getElementById("consent-analytics").checked,
            preferences: document.getElementById("consent-preferences")
              .checked,
            marketing: document.getElementById("consent-marketing").checked,
          });
          consentOptionsPopup.classList.remove("active");
          hideBanner();
        });
      document
        .getElementById("btn-accept-all-3")
        .addEventListener("click", function () {
          setConsent({
            necessary: true,
            analytics: true,
            preferences: true,
            marketing: true,
          });
          SelectPopupState()
          hideBanner();
        });
      

      if (localStorage.getItem("consentMode") === null) {

        document.getElementById("cookie-consent-banner").style.display =
          "block";
      }

      const consentOptionsPopup = document.getElementById(
        "consentOptionsPopup"
      );

      function syncConsentToggles() {
  let saved;
  try {
    saved = JSON.parse(localStorage.getItem("consentMode"));
  } catch (e) {
    saved = null;
  }
  if (!saved) return;

  const map = {
    "consent-analytics": saved.analytics_storage,
    "consent-preferences": saved.personalization_storage,
    "consent-marketing": saved.ad_storage,
  };

  Object.keys(map).forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.checked = map[id] === "granted";
  });
}

let popupWasOpen = consentOptionsPopup.classList.contains("active");
new MutationObserver(() => {
  const isOpen = consentOptionsPopup.classList.contains("active");
  if (popupWasOpen && !isOpen) {
    syncConsentToggles();
  }
  popupWasOpen = isOpen;
}).observe(consentOptionsPopup, {
  attributes: true,
  attributeFilter: ["class"],
});

syncConsentToggles();

      const checkboxes = document.querySelectorAll(".checkbox-body");

      checkboxes.forEach((box) => {
        box.addEventListener("click", function (event) {
          event.stopPropagation();
        });
      });

      const consentItems = document.querySelectorAll(".consent-item");

      consentItems.forEach((item) => {
        item.addEventListener("click", () => {
          item.classList.toggle("opened");
        });
      });

      document
        .getElementById("cookie-setting")
        .addEventListener("click", SelectPopupState);

      document
        .getElementById("consentOptionsPopupClose")
        .addEventListener("click", SelectPopupState);

      function SelectPopupState() {
        consentOptionsPopup.classList.toggle("active");
      }
    })();
 

document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = Object.fromEntries(urlParams.entries());

    var pathname = window.location.pathname;
    var pathSegments = pathname.replace(/\/$/, '').split('/');
    var lpValue = pathSegments[pathSegments.length - 1];

    if (pathname === '/' || lpValue.trim() === '') {
      lpValue = 'home_page';
    }

    if (!utmParams.lp || utmParams.lp?.trim() === '') {
      utmParams.lp = lpValue;
    }

    document.querySelectorAll("a[href]").forEach(function (link) {
      let href = new URL(link.href, window.location.origin);
      let paramsAdded = false;

      for (const [key, value] of Object.entries(utmParams)) {
        if (key !== "" && value.trim() !== "") {
          href.searchParams.set(key, value);
          paramsAdded = true;
        }
      }

      if (Object.keys(utmParams).length === 0) {
        href.searchParams.set("get_param", "1");
      }

      link.href = href.toString();
    });
  });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
